import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';
import spacing from 'styles/spacing';

const useStyles = makeStyles({
  formMessage: {
    fontSize: '14px',
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.15px',
    lineHeight: '16px',
    marginBottom: '30px',
  },
  bodyContent: {
    flexGrow: 1,

    '& > div:first-child': {
      paddingBottom: '34px',
    },
    '& > div': {
      paddingBottom: '24px',
    },
    '& > div:last-child': {
      paddingBottom: '0',
    },
  },
  footer: {
    '& > button': {
      marginLeft: '6px',
    },
  },
  content: {
    '& section > div:first-of-type': {
      marginLeft: 0,
      marginRight: 0,
    },

    '& section > p:first-of-type': {
      fontSize: fonts.sizes.xsmall,
      fontWeight: fonts.weights.normal,
      marginTop: spacing.xsmall,
      marginLeft: spacing.xsmall,
      letterSpacing: '0.4px',
      color: colors.gray,
    },

    '& aside > div > div:first-of-type': {
      alignItems: 'center',
    },

    '& h4': {
      fontSize: fonts.sizes.small,
      fontWeight: fonts.weights.normal,
      color: colors.uploadedItemLegend,
      lineHeight: '20px',
    },
  },
});

export default useStyles;
